export default __webpack_public_path__ + "static/media/policy.c37a0441.svg";